import { useQuery } from 'hooks/sympl-query';
import useNavigationContext from 'hooks/context/nav-context';
import { GET_CAMPAIGN_VALUES } from 'graphql/campaign-values/queries';
import { CampaignValuesState } from 'utils/campaignValues';

/**
 * SYM-6351. The selected campaign's job title and location, notices and out-of-date ads.
 *
 * Every part of the editor that needs it calls this hook: the query library keeps ONE copy per
 * campaign, so the Job title row, the messages above the ads and the markers in the ad rail all
 * read the same answer, and a refetch from any of them updates all three. No context needed.
 *
 * Skipped while no campaign is selected, as every query that depends on it is.
 */
const useCampaignValues = (forVacancy?: number) => {
  const { activeVacancy: selected } = useNavigationContext();
  // A screen that names its campaign (the Start button) asks about that one.
  const activeVacancy = forVacancy ?? selected;

  const { data, loading, refetch } = useQuery<
    {
      campaignValuesState: { id: number; campaignValues: CampaignValuesState };
    },
    { vacancyId: number }
  >(GET_CAMPAIGN_VALUES, {
    skip: !activeVacancy,
    variables: { vacancyId: activeVacancy as number },
    fetchPolicy: 'cache-and-network',
  });

  return {
    vacancyId: activeVacancy as number | undefined,
    state: data?.campaignValuesState?.campaignValues,
    loading,
    refetch,
  };
};

export default useCampaignValues;
